import { Link } from 'react-router-dom';
import { hotVideos } from '@/mocks/videos';

export default function HotVideos() {
  return (
    <section className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-2">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-500">全网最热视频，大家都在看</p>
          </div>
          <Link
            to="/category/dianshiju"
            className="flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap cursor-pointer"
          >
            查看更多 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {hotVideos.map((video) => (
            <Link
              key={video.id}
              to="/category/dianshiju"
              className="group bg-background-100 rounded-xl overflow-hidden cursor-pointer transition-all duration-300 hover:scale-[1.02]"
            >
              <div className="relative w-full aspect-video overflow-hidden">
                <img
                  src={video.thumbnail}
                  alt={video.title}
                  title={`${video.title} - 黄瓜视频在线免费观看`}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-0.5 rounded text-xs font-medium bg-primary-500 text-white">
                    {video.quality}
                  </span>
                </div>
                <div className="absolute bottom-3 right-3">
                  <span className="text-xs text-white/90 bg-black/50 px-2 py-0.5 rounded">
                    {video.duration}
                  </span>
                </div>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="w-14 h-14 flex items-center justify-center rounded-full bg-primary-500/90 text-white">
                    <i className="ri-play-fill text-2xl ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-base text-foreground-900 mb-1.5 line-clamp-1">
                  {video.title}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-1 mb-3">
                  {video.description}
                </p>
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line w-3.5 h-3.5 flex items-center justify-center"></i>
                    {video.views}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-star-fill text-accent-500 w-3.5 h-3.5 flex items-center justify-center"></i>
                    {video.rating}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}